<template>
  <div
    class="
      hidden
      items-end
      bg-gray
      border-0 border-solid border-b-2px border-gray-700
      pt-12
      pb-5
      lg:flex
    "
  >
    <div class="flex-shrink-0 mr-10 w-56"></div>
    <div class="flex-1 text-6 text-red font-black uppercase px-10">
      {{ __('form.product_title') }}
    </div>
    <div class="w-80 text-6 text-red font-black uppercase px-10">
      <div class="w-40 text-center mx-auto">{{ __('form.amount_title') }}</div>
    </div>
    <div class="w-72 text-6 text-red text-center font-black uppercase px-10">
      {{ __('form.total_title') }}
    </div>
    <div class="w-32 ml-auto pl-16"></div>
  </div>

  <div>
    <slot></slot>
  </div>
</template>
